var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{staticClass:"text-left",attrs:{"id":_vm.modalId,"title":`Edit ${_vm.value.name}`,"size":"sm"},on:{"on-hide":_vm.resetFormData}},[_c('tax-rates-form',_vm._b({key:_vm.formKey,attrs:{"new-form":false},on:{"on-submit":_vm.update,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'tax-rates-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }